<template>
  <div>
    <div
      class="audit-card"
      v-if="
        detailInfo?.auditStatus === 'PENDING' ||
        detailInfo?.auditStatus === 'REJECTED'
      "
    >
      <div class="audit-header">
        <span class="audit-title">{{ getAuditMessage() }}</span>
      </div>
      <div
        v-if="detailInfo?.auditStatus === 'REJECTED'"
        class="audit-reject-reason"
      >
        <div class="audit-reject-reason__label">拒绝原因</div>
        <div class="audit-reject-reason__text">
          {{ detailInfo?.auditRemark || "暂无具体原因，请联系工作人员。" }}
        </div>
      </div>
      <div class="audit-content" v-if="detailInfo?.auditStatus === 'PENDING'">
        <div
          class="audit-message"
          v-if="detailInfo?.registrationReviewConfig?.type == 'PICTURE'"
        >
          <img
            :src="getFileFullUrl(detailInfo?.registrationReviewConfig?.value)"
            alt=""
            @click="
              handleImagePreview(
                getFileFullUrl(detailInfo?.registrationReviewConfig?.value)
              )
            "
          />
        </div>
        <div
          class="audit-video"
          v-if="detailInfo?.registrationReviewConfig?.type == 'VIDEO'"
        >
          <video
            :src="getFileFullUrl(detailInfo?.registrationReviewConfig?.value)"
            height="200"
            width="100%"
            controls
          ></video>
        </div>
        <div
          class="audit-text"
          v-if="detailInfo?.registrationReviewConfig?.type == 'TEXT'"
        >
          {{ detailInfo?.registrationReviewConfig?.value || "-" }}
        </div>
      </div>
    </div>

    <div class="detail-card">
      <div class="card-header">
        <span class="card-title">个人信息</span>
      </div>
      <div v-if="detailInfo?.candidaterProfile">
        <div class="card-content">
          <div class="detail-row">
            <span class="detail-label">姓名：</span>
            <span class="detail-value">{{
              detailInfo?.candidaterProfile?.name || "-"
            }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">证件号：</span>
            <span class="detail-value">{{
              detailInfo?.candidaterProfile?.idCard || "-"
            }}</span>
          </div>
        </div>
      </div>
      <div v-else class="no-data">未填写</div>

      <div class="modify-btn-container">
        <van-button
          class="modify-btn"
          type="primary"
          @click="handleModifyPersonal"
        >
          {{ detailInfo?.candidaterProfile ? "去修改" : "去填写" }}
        </van-button>
      </div>
    </div>

    <div class="detail-card">
      <div class="card-header">
        <span class="card-title">企业信息</span>
      </div>
      <div class="card-content">
        <div v-if="detailInfo.company">
          <div class="detail-row">
            <span class="detail-label">企业：</span>
            <span class="detail-value">{{
              detailInfo.company?.name || "-"
            }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">统一社会信用代码：</span>
            <span class="detail-value">{{
              detailInfo.company?.socialCreditCode || "-"
            }}</span>
          </div>
        </div>
        <div v-else class="no-data">未填写</div>

        <div class="modify-btn-container">
          <van-button
            class="modify-btn"
            type="primary"
            @click="handleModifyCompany"
          >
            {{ detailInfo.company ? "去修改" : "去选择" }}
          </van-button>
        </div>
      </div>
    </div>

    <div class="sign-btn-container">
      <!-- 报名中状态，可以提交 -->
      <van-button
        class="sign-btn"
        type="primary"
        @click="handleSignUp"
        v-if="detailInfo?.auditStatus === 'FILLING_IN'"
        :loading="loding"
      >
        提交报名
      </van-button>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";

import { get, post } from "@/request.js";
import { Toast, ImagePreview } from "vant";
import { getFileFullUrl } from "@/utils";

import { useRouter } from "vue-router";
const props = defineProps({
  detailInfo: {
    type: Object,
    default: () => ({}),
  },
});
const emit = defineEmits(["submitSuccess"]);
const router = useRouter();
const loding = ref(false);
// const contactInfo = ref({});

// 获取审核消息文本
const getAuditMessage = () => {
  if (props.detailInfo?.auditStatus === "PENDING") {
    return "报名已提交成功，完成缴费且审核通过后，账号将自动开通，如有疑问可在工作时间联系工作人员 020-84453099";
  }
  if (props.detailInfo?.auditStatus === "REJECTED") {
    return "报名未通过审核，如有疑问可在工作时间联系工作人员 020-84453099";
  }
  return "报名成功";
};

// 图片预览
const handleImagePreview = (imageUrl) => {
  ImagePreview({
    images: [imageUrl],
    closeable: true,
  });
};

const handleModifyPersonal = () => {
  router.push("/userInfo");
};
const handleModifyCompany = () => {
  router.push({
    path: "/chooseEnterprise",
    query: { courseId: props.detailInfo.courseId },
  });
};
const handleSignUp = async () => {
  if (!props.detailInfo.candidaterProfile) {
    Toast("请填写个人信息");
    return;
  }
  if (!props.detailInfo.company) {
    Toast("请先选择企业");
    return;
  }
  loding.value = true;
  try {
    const res = await post(
      `/api/my/registration/submit/${props.detailInfo.courseId}`
    );
    if (res.success) {
      Toast("报名成功");
      //更新详情
      emit("submitSuccess");
    }
  } catch (error) {
    // 错误信息已经在 request.js 的拦截器中处理并显示
    console.error("报名失败:", error);
  } finally {
    loding.value = false;
  }
};
// const getContact = async () => {
//   console.log(88);
//   const res = await get("/api/my/registration/get-contact/info");
//   if (res.success) {
//     contactInfo.value = res.data;
//   }
// };
// onMounted(() => {
// });
</script>
<style scoped lang="less">
.audit-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  .audit-header {
    margin-bottom: 12px;

    .audit-title {
      font-size: 16px;
      font-weight: 600;
      color: #f56565;
      line-height: 1.8;
    }
  }

  .audit-reject-reason {
    background: #fff7ed;
    border: 1px solid #ffd8bf;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 12px;

    &__label {
      font-size: 13px;
      font-weight: 600;
      color: #c2410c;
      margin-bottom: 6px;
    }

    &__text {
      font-size: 14px;
      line-height: 1.6;
      color: #4b5563;
      word-break: break-word;
    }
  }

  .audit-content {
    .audit-message {
      font-size: 14px;
      color: #666;
      line-height: 1.5;
      img {
        width: 100%;
        height: 200px;
        object-fit: contain;
        cursor: pointer;
      }
    }
    .audit-text {
      font-size: 16px;
      color: #333333;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}

.detail-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  .card-header {
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 16px;

    .card-title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }
  .no-data {
    text-align: center;
    padding: 30px 0;
    font-size: 16px;
    color: #666666;
  }
  .modify-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;

    .modify-btn {
      background: linear-gradient(135deg, #1890ff, #36cfc9);
      border: none;
      width: 120px;
      padding: 6px;
      border-radius: 20px;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .card-content {
    .detail-row {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      &:last-of-type {
        margin-bottom: 20px;
      }

      .detail-label {
        font-size: 16px;
        color: #333;
        font-weight: 400;
        min-width: 120px;
      }

      .detail-value {
        font-size: 16px;
        color: #666;
        flex: 1;
      }
    }
  }
}

.sign-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
  .sign-btn {
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    border: none;
    width: 80%;
    border-radius: 26px;
    font-size: 16px;
    font-weight: 500;
    padding: 26px;
  }
}
</style>
